(() => {
  if (window.SnowshanGiftCart) return;
  const node = document.querySelector('[data-snowshan-gifts]');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const ids = config.ids.map(String);
  const base = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let bridge;
  const request = async (path, body) => {
    const response = await fetch(`${base}${path}`, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || config.error);
    return result;
  };
  const reconcile = async ({ announce = true } = {}) => {
    let cart = await request('cart.js');
    const qualifies = cart.items.reduce((sum, item) => sum + (!ids.includes(String(item.variant_id || item.id)) && !item.gift_card && Number(item.final_price ?? item.price) > 0 ? item.quantity : 0), 0) >= config.minimum;
    const seen = new Set();
    const updates = {};
    for (const item of cart.items) {
      const id = String(item.variant_id || item.id);
      if (!ids.includes(id)) continue;
      const wanted = qualifies && !seen.has(id) ? 1 : 0;
      if (item.quantity !== wanted) updates[item.key] = wanted;
      if (wanted) seen.add(id);
    }
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    const sectionRequest = sections.length ? { sections, sections_url: location.pathname } : {};
    let rendered;
    let changed = false;
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', { updates, ...sectionRequest });
      rendered = cart.sections; changed = true;
    }
    const missing = qualifies ? ids.filter(id => !seen.has(id)) : [];
    if (missing.length) {
      const result = await request('cart/add.js', { items: missing.map(id => ({ id: Number(id), quantity: 1, properties: { _snowshan_bonus: 'tea-table-v1', Benefit: 'Complimentary; provided after purchase' } })), ...sectionRequest });
      rendered = result.sections; changed = true;
      cart = await request('cart.js');
    }
    if (changed && announce) {
      if (bridge) {
        const deferred = bridge.CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        const event = new bridge.CartLinesUpdateEvent({ action: 'change', context: 'cart', lines: ids.map(id => ({ merchandiseId: id, quantity: qualifies ? 1 : 0 })), promise: deferred.promise });
        event.snowshanGiftSync = true;
        document.dispatchEvent(event);
        deferred.resolve({ cart: bridge.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: rendered, source: 'snowshan-gifts', didError: false } });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, sections: rendered, source: 'snowshan-gifts' } }));
    }
    return { cart, sections: rendered, qualifies, changed };
  };
  const sync = options => {
    const job = queue.catch(() => {}).then(() => reconcile(options));
    queue = job;
    return job;
  };
  const notifyFailure = error => {
    for (const root of document.querySelectorAll('[data-sr-builder]')) {
      const status = root.querySelector('[data-sr-status]');
      if (status) { status.textContent = config.error; status.dataset.error = 'true'; }
    }
    document.dispatchEvent(new CustomEvent('snowshan:gift-error', { detail: { message: error.message } }));
  };
  window.SnowshanGiftCart = { sync, ids };
  document.addEventListener('cart:refresh', event => { if (event.detail?.source !== 'snowshan-gifts') sync().catch(notifyFailure); });
  window.addEventListener('pageshow', event => { if (event.persisted) sync().catch(notifyFailure); });
  window.addEventListener('focus', () => sync().catch(notifyFailure));
  import('@shopify/events').then(events => {
    bridge = events;
    document.addEventListener(events.StandardEvents.cartLinesUpdate, event => {
      if (event.snowshanGiftSync) return;
      Promise.resolve(event.promise).then(() => sync()).catch(notifyFailure);
    });
  }).catch(() => {});
  document.addEventListener('submit', event => {
    const form = event.target;
    const target = event.submitter;
    if (!(form instanceof HTMLFormElement) || !(target?.name === 'checkout' || /\/checkout(?:\?|$)/.test(form.action)) || form.dataset.snowshanCheckoutReady === 'true') return;
    event.preventDefault();
    sync().then(() => location.assign(`${base}checkout`)).catch(notifyFailure);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/checkout(?:\/|$)/.test(url.pathname)) return;
    event.preventDefault();
    sync().then(() => location.assign(link.href)).catch(notifyFailure);
  }, true);
  sync().catch(notifyFailure);
})();

